import { render } from "./BadgePrint.vue?vue&type=template&id=03697948&scoped=true"
import script from "./BadgePrint.vue?vue&type=script&lang=js"
export * from "./BadgePrint.vue?vue&type=script&lang=js"

import "./BadgePrint.vue?vue&type=style&index=0&id=03697948&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03697948"]])

export default __exports__